// 配置文件
const URL_EASYMOCK = {
  // 测试地址
  // online: 'http://localhost:3000/mock/5d46b8c13d750a00144d4120/api',
  // 线上地址
  online: window.location.protocol +'//paper.aizhishifm.com/consumer',
}

// channelId
const channelId = 1;

export { URL_EASYMOCK, channelId }
